// Types
// Url
import useMarketingUrl from '@/utils/urls/useMarketingUrl';

import type { NotificationSubscriptionProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

const RenewManualPlanReminder = ({ notification }: NotificationSubscriptionProps) => {
    const { marketingUrl } = useMarketingUrl();
    return (
        <Notification
            dataNotification={notification}
            goToExternalUrl={`${marketingUrl('contact')}?subject=pricing`}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="paid-data" />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.renew_manual_plan_reminder.title" />
                <Notification.Description i18nKey="commons:notifications.renew_manual_plan_reminder.description" />
            </Notification.Content>
        </Notification>
    );
};

export default RenewManualPlanReminder;
